export default {
  yes: { id: 'yes' },
  no: { id: 'no' },
  active: { id: 'active' },
  pending: { id: 'pending' },
  future: { id: 'future' },
  complete: { id: 'complete' },
  sendForReview: { id: 'send_for_review' },
  sendBackFromReview: { id: 'send_back_from_review' },
  completeOfTotal: { id: 'complete_of_total' },
  jobsComplete: { id: 'events_complete' },
  jobsInProgress: { id: 'events_in_progress' },
  createNewJob: { id: 'create_new_job' },
  site: { id: 'site' },
  notStarted: { id: 'not_started' },
  inProgress: { id: 'in_progress' },
  completed: { id: 'completed' },
  jobStates: { id: 'job_states' },
  apply: { id: 'apply' },
  chooseLocus: { id: 'choose_locus' },
  itemsSelected: { id: 'items_selected' },
  chooseLocusGroup: { id: 'choose_locus_group' },
  completeJob: { id: 'complete_job' },
  delete: { id: 'delete' },
  deleteJob: { id: 'delete_job' },
  deleteJobSeries: { id: 'delete_job_series' },
  reopen: { id: 'reopen' },
  reopenJob: { id: 'reopen_job' },
  confirmJobMessage: { id: 'confirm_job_message' },
  confirmJobSeriesMessage: { id: 'confirm_job_series_message' },
  plan: { id: 'plan' },
  planJob: { id: 'plan_job' },
  createWorkflowMessage: { id: 'create_workflow_message' },
  cancel: { id: 'cancel' },
  select: { id: 'select' },
  reopenTask: { id: 'reopen_task' },
  completeTask: { id: 'complete_task' },
  confirmTaskMessage: { id: 'confirm_task_message' },
  next: { id: 'next' },
  finish: { id: 'finish' },
  allSelected: { id: 'all_selected' },
  chooseWorkflow: { id: 'choose_workflow' },
  chooseObject: { id: 'choose_object' },
  assignTasks: { id: 'assign_tasks' },
  setSchedule: { id: 'set_schedule' },
  groups: { id: 'groups' },
  users: { id: 'users' },
  assignedTo: { id: 'assigned_to' },
  me: { id: 'me' },
  createdBy: { id: 'createdBy' },
  duplicate: { id: 'duplicate' },
  duplicateWithData: { id: 'duplicate_with_data' },
  duplicateTask: { id: 'duplicate_message' },
  deleteTask: { id: 'delete_task' },
  chooseAssignees: { id: 'choose_assignees' },
  reassign: { id: 'reassign' },
  reassignSeries: { id: 'reassign_series' },
  reassignSuccessMessage: { id: 'reassign_success_message' },
  reassignErrorMessage: { id: 'reassign_error_message' },
  createJobSuccessMessage: { id: 'create_job_success_message' },
  createJobErrorMessage: { id: 'create_job_error_message' },
  overdue: { id: 'overdue' },
  repetitionDaily: { id: 'daily' },
  repetitionWeekly: { id: 'weekly' },
  repetitionBiweekly: { id: 'biweekly' },
  repetitionMonthly: { id: 'monthly' },
  oneDay: { id: 'one_day' },
  threeDays: { id: 'three_days' },
  oneWeek: { id: 'one_week' },
  twoWeeks: { id: 'two_weeks' },
  oneMonth: { id: 'one_month' },
  never: { id: 'never' },
  daily: { id: 'daily' },
  weekly: { id: 'weekly' },
  biweekly: { id: 'biweekly' },
  monthly: { id: 'monthly' },
  planForSpecificDates: { id: 'plan_for_specific_dates' },
  start: { id: 'start' },
  end: { id: 'end' },
  repeat: { id: 'repeat' },
  repeatUntil: { id: 'repeat_until' },
  createJobSeries: { id: 'create_job_series' },
  createJobSeriesMessage: { id: 'create_job_series_message' },
  showImage: { id: 'show_image' },
  hideImage: { id: 'hide_image' },
  showVideo: { id: 'show_video' },
  hideVideo: { id: 'hide_video' },
  jobs: { id: 'jobs' },
  minCharsHint: { id: 'minimum_input_characters' },
  or: { id: 'or' },
  uploadFromGallery: { id: 'upload_from_gallery' },
  scanQrBarcode: { id: 'scan_qr_barcode' },
  enterTheDataOrScan: { id: 'enter_the_data_or_scan' },
  cannotDetectTheQrCode: { id: 'cannot_detect_the_qr_code' },
  wrongFormat: { id: 'wrong_format' },
  photoIsTooLarge: { id: 'photo_is_too_large' },
  valueOutOfRange: { id: 'value_out_of_range' },
  usuallyTheRangeIs: { id: 'usually_the_range_is' },
  maxCharsHint: { id: 'maximum_input_characters' },
  lastUpdated: { id: 'last_updated' },
  shouldBeLater: { id: 'should_be_later' },
  shouldBeEqOrHigher: { id: 'should_be_eq_or_higher' },
  shouldBeEq: { id: 'should_be_eq' },
  shouldBeEqOrLower: { id: 'should_be_eq_or_lower' },
  shouldBeLower: { id: 'should_be_lower' },
  assignToAll: { id: 'assign_to_all' },
  clearAll: { id: 'clear_all' },
  search: { id: 'search' },
  respectFilters: { id: 'respect_filters' },
  valuesAreDifferent: { id: 'values_are_different' },
  startDateAndTime: { id: 'start_date_and_time' },
  endDateAndTime: { id: 'end_date_and_time' },
  daySymbol: { id: 'day_symbol' },
  hourSymbol: { id: 'hour_symbol' },
  minuteSymbol: { id: 'minute_symbol' },
  chosen: { id: 'chosen' },
  clearSelection: { id: 'clear_selection' },
  reasonForDeletion: { id: 'reason_for_deletion' },
  setValueFor: { id: 'set_value_for' },
  sort: { id: 'sort' },
  urgent: { id: 'urgent' },
  sortAsc: { id: 'sort_asc' },
  sortDesc: { id: 'sort_desc' },
  date: { id: 'date' },
  created: { id: 'created' },
  newestToOldest: { id: 'newest_to_oldest' },
  oldestToNewest: { id: 'oldest_to_newest' },
  due: { id: 'due' },
  sign: { id: 'sign' },
  my: { id: 'my' },
  signature: { id: 'signature' },
  deleteSuccessMessage: { id: 'delete_success_message' },
  deleteSignatureInputMessage: { id: 'delete_signature_input_message' },
  saveSuccessMessage: { id: 'save_success_message' },
  downloadPdf: { id: 'download_pdf' },
  printPdf: { id: 'print_pdf' },
}
